// extracted by mini-css-extract-plugin
export const cruiseRecap = "CruiseRecap-module--cruise-recap--SdXG6";
export const withArrivalDate = "CruiseRecap-module--with-arrival-date--35y6i";